import { zeroTo } from "src/utils";

/** Generates evenly spaced tick values within a numeric range. */
export function getNumberTicks(data: number[], count: number): number[] {
  const min = data.min();
  const max = data.max();
  if (min === max) return [min];
  return zeroTo(count).map((i) => min + ((max - min) / (count - 1)) * i);
}

/** Generates evenly spaced tick dates within a date range. */
export function getDateTicks(data: Date[], count: number, skipLast?: boolean): Date[] {
  const min = data.min();
  const max = data.max();
  if (min.getTime() === max.getTime()) return [min];
  return zeroTo(skipLast ? count - 1 : count).map(
    (i) => new Date(min.getTime() + ((max.getTime() - min.getTime()) / (count - 1)) * i),
  );
}
